import { FC } from "react";
import { Helmet } from "react-helmet";
import { BuildingOfficeIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export interface LoginCommonPageProps {
  className?: string;
}

const LoginCommonPage: FC<LoginCommonPageProps> = ({ className = "" }) => {

  const { t, ready } = useTranslation("translation");
  if (!ready) return null;


  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>{t("translation:login.title")} || TRIBYOU</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          {t("translation:login.heading")}
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          <div className="flex flex-row gap-3">
            <div
              className="nc-will-change-transform min-h-[10rem] flex flex-col justify-center items-center w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-6 transform transition-transform sm:px-6"
            >
              <div className="flex-shrink-0"><BuildingOfficeIcon height={25} width={25} /></div>
              <h3 className="flex-grow text-center text-sm font-bold text-neutral-700 dark:text-neutral-300 sm:text-sm">
                {t("translation:login.clientTypeHost.header")}
              </h3>

              <span className="text-xs mt-2 text-stone-700">
                {t("translation:login.clientTypeHost.description")}
              </span>

              <div className="flex gap-2 mt-4 w-full">
                <a
                  href="/login-host"
                  className="flex-1 px-3 py-2 bg-transparent border border-primary-6000 text-primary-6000 text-xs font-semibold rounded hover:bg-primary-6000 hover:text-white transition-colors text-center"
                >
                  {t("translation:login.title")}
                </a>
                <a
                  href="/become-host"
                  className="flex-1 px-3 py-2 bg-transparent border border-neutral-400 dark:border-neutral-500 text-neutral-900 dark:text-neutral-100 text-xs font-semibold rounded hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors text-center"
                >
                  {t("translation:hostLogin.registerLink.linkText")}
                </a>
              </div>
            </div>

            <div
              className="nc-will-change-transform min-h-[10rem] flex flex-col justify-center items-center w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-6 transform transition-transform sm:px-6"
            >
              <div className="flex-shrink-0"><UserCircleIcon height={25} width={25} /></div>
              <h3 className="flex-grow text-center text-sm font-bold text-neutral-700 dark:text-neutral-300 sm:text-sm">
                {t("translation:login.clientTypeUser.header")}
              </h3>

              <span className="text-xs mt-2 text-stone-700">
                {t("translation:login.clientTypeUser.description")}
              </span>

              <div className="flex gap-2 mt-4 w-full">
                <a
                  href="/login-client"
                  className="flex-1 px-3 py-2 bg-transparent border border-primary-6000 text-primary-6000 text-xs font-semibold rounded hover:bg-primary-6000 hover:text-white transition-colors text-center"
                >
                  {t("translation:login.title")}
                </a>
                <a
                  href="/signup-client"
                  className="flex-1 px-3 py-2 bg-transparent border border-neutral-400 dark:border-neutral-500 text-neutral-900 dark:text-neutral-100 text-xs font-semibold rounded hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors text-center"
                >
                  {t("translation:userLogin.registerLink.linkText")}
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default LoginCommonPage;
